
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <form #deploymentForm="ngForm" (ngSubmit)="setup()">
      <div class="modal-header">
        <h4 class="modal-title">Setup Workflows</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col">
            <label class="required" for="defectOrderName">Order Name:</label>
            <input class="form-control" id="defectOrderName" [(ngModel)]="defectOrderName" name="defectOrderName" maxlength="100" required>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label class="required" for="defectDeploymentName">Deployment Name:</label>
            <input class="form-control" id="defectDeploymentName" [(ngModel)]="defectDeploymentName" name="defectDeploymentName" maxlength="100" required>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit">Setup</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>